import React from 'react';
import { Button, ButtonProps } from '@konfio/komp-library';
import { motion, Variants } from 'framer-motion';

const ButtonWrapper: React.FC<ButtonProps> = props => {
  const buttonVariants: Variants = {
    offscreen: {
      opacity: 0
    },
    onscreen: {
      opacity: 1
    }
  };

  return (
    <motion.div initial='offscreen' animate='onscreen' variants={buttonVariants}>
      <Button {...props} />
    </motion.div>
  );
};

export default ButtonWrapper;
